export function slugify(name) {
    return encodeURIComponent(
        String(name || "")
            .trim()
            .toLowerCase()
            .replace(/&/g, "and")
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "")
    );
}

export function unslugify(slug) {
    if (!slug) return "";
    const s = decodeURIComponent(slug).replace(/-/g, " ");
    // Title case
    return s.replace(/\w\S*/g, (t) => t.charAt(0).toUpperCase() + t.slice(1));
}